import { render, staticRenderFns } from "./LearnAboutTags.vue?vue&type=template&id=3378c890&scoped=true"
import script from "./LearnAboutTags.vue?vue&type=script&lang=js"
export * from "./LearnAboutTags.vue?vue&type=script&lang=js"
import style0 from "./LearnAboutTags.vue?vue&type=style&index=0&id=3378c890&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3378c890",
  null
  
)

export default component.exports